import React, { useState } from "react";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import * as S from "./styles"; // Se quiser usar styled-components
import { MdArrowBack } from "react-icons/md";
import { useNavigate } from "react-router-dom";

export default function Configuracoes() {
  const [dias, setDias] = useState(3);
  const [email, setEmail] = useState("");
  const [horario, setHorario] = useState("08:00");
  const [ativo, setAtivo] = useState(true);
  const navigate = useNavigate();

  const salvar = () => {
    const configuracao = {
      dias_antes: parseInt(dias),
      email_destinatario: email,
      horario_envio: horario,
      ativo: ativo,
    };
    alert("Configuração salva:\n" + JSON.stringify(configuracao, null, 2));
  };

  return (
    <>
      <Header />
      <S.BackButton onClick={() => navigate("/financeiro")}> 
        <MdArrowBack size={20} style={{ marginRight: 6 }} />
        Voltar
      </S.BackButton>
      <S.Container>
        <S.Form>
          <S.Title>Configurações de Alerta</S.Title>

          <S.InputGroup>
            <S.Label>Dias de antecedência para alerta:</S.Label>
            <S.Input
              type="number"
              value={dias}
              onChange={(e) => setDias(e.target.value)}
            />
          </S.InputGroup>

          <S.InputGroup>
            <S.Label>E-mail do destinatário:</S.Label>
            <S.Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </S.InputGroup>

          <S.InputGroup>
            <S.Label>Horário preferencial de envio:</S.Label>
            <S.Input
              type="time"
              value={horario}
              onChange={(e) => setHorario(e.target.value)}
            />
          </S.InputGroup>

          <S.InputGroupCheckbox>
            <input
              type="checkbox"
              checked={ativo}
              onChange={(e) => setAtivo(e.target.checked)}
            />
            <span>Ativar envio automático de alertas</span>
          </S.InputGroupCheckbox>

          <S.Button onClick={salvar}>Salvar Configurações</S.Button>
        </S.Form>
      </S.Container>
      <Footer />
    </>
  );
}
